module.exports = {"DATE_SELECT_DAY":"Día","DATE_SELECT_MONTH":"Mes","DATE_SELECT_YEAR":"Año"}